<div class="flex-1 flex-row justify-between items-center">
  <h1>{{ 'review_overview.title' | translate }}</h1>
  @if ((canCreateReview$ | async) && !(reviewsLoading$ | async)) {
    <mat-chip-listbox>
      <mat-chip-option (click)="newReview()">{{ 'review_overview.write_review' | translate }}</mat-chip-option>
    </mat-chip-listbox>
  }
</div>
<div class="review-summary flex-1 flex-row justify-between items-center" *ngVar="(reviewOverview$ | async) as overview">
  <ng-container *showSpinner="!overview && overviewLoading$ | async">
    @if (overview) {
      <div class="summary-rating flex-col justify-between items-start">
        <h1>{{ (overview.review_score / 20) | i18n_number: '1.1-1' | async }}</h1>
        <app-review-rating [value]="overview.review_score" [editable]="false"></app-review-rating>
        @if (( totalReviewCount$ | async ); as totalReviewCount) {
          <span>
            {{ 'review_overview.review_count' | translate: { totalReviewCount } }}
          </span>
        }
      </div>
      <div class="summary-lines flex-col justify-between items-start">
        @for (division of reviewDivision$ | async; track division; let i = $index) {
          <div class="rating-line flex-1 flex-row justify-between items-center gap-2"
            [matTooltip]="division.tooltip">
            <app-review-rating height="15px" [editable]="false" [value]="(5 - i) * 20"></app-review-rating>
            <div class="rating-bar">
              <span [style.--order]="i" class="rating" [style.width.%]="division.percentage"></span>
            </div>
            <span>{{division.count}}</span>
          </div>
        }
      </div>
    }
  </ng-container>
</div>
<div [class.full-overview]="!preview" (scroll)="onScroll($event)">
  @if ((reviews$ | async); as reviews) {
    <ng-container *showSpinner="reviewsLoading$ | async">
      <ng-container *noContent="!(reviews?.length > 0); title: 'review_overview.no_content' | translate">
        @for (review of (reviews$ | async); track review; let i = $index) {
          <app-review (delete)="reviewDeleted($event)" [style.--order]="(i + 1) % 5" [review]="review"></app-review>
        }
      </ng-container>
    </ng-container>
  }
</div>
@if (preview && (metaData$ | async).total > pageSize) {
  <button mat-flat-button color="primary" (click)="viewAll()">
    {{ 'review_overview.view_all' | translate }}
  </button>
}
